<template>
  <div>
    <page-intro>
      <template v-slot:heading>Инструкции</template>
      <template v-slot:info>
        <p>Инструкции по работе в облачной 1С.</p>
      </template>
    </page-intro>
    <div v-loading="$mip('getInstructionsList')" class="widget">
      <div class="widget__body py-0">
        <paginator :full-data="instructions" :page-size="pageSize" controls-class="flex-x-center mb-24">
          <template v-slot="{ page }">
            <ul>
              <li v-for="(instruction, index) in page" :key="instruction.id">
                <router-link
                  :to="{
                    name: 'instruction',
                    params: { instructionsCategoryId: instruction.categoryId, instructionId: instruction.id }
                  }"
                  class="text-link d-block py-24">
                  {{ instruction.heading }}
                </router-link>
                <div v-if="index !== page.length - 1" class="divider my-0" />
              </li>
            </ul>
          </template>
        </paginator>
      </div>
    </div>
  </div>
</template>

<script>
  import PageIntro from '@/components/PageIntro.vue'
  import Paginator from '@/components/Paginator.vue'

  export default {
    components: {
      PageIntro,
      Paginator
    },

    props: {
      instructionsCategoryId: [ Number, String ]
    },

    data() {
      return {
        instructions: [],
        pageSize: 5
      }
    },

    watch: {
      instructionsCategoryId: {
        handler() {
          if (this.instructionsCategoryId) this.fetchInstructions()
        }
      }
    },

    async created() {
      this.fetchInstructions()
    },

    methods: {
      async fetchInstructions() {
        const { data } = await this.$http.getInstructions(this.instructionsCategoryId || '')
        this.instructions = data
      }
    }
  }
</script>
